'use client';

import { cva } from 'class-variance-authority';
import { classes } from '../../../utils/classes';
import { SoftHyphenInjector } from '../../SoftHyphenInjector';
import type { HeadlineLevel, HeadlineType } from '../types';

const headlineStyles = cva('hyphens-auto', {
  variants: { textAlign: { center: 'text-center', left: 'text-left', right: 'text-right' } },
});

export const SubHeadline = ({ data }: { data: HeadlineType }) => {
  const {
    field_text_subheadline: subHeadlineText,
    field_text_align: textAlign,
    field_font: headlineFont,
    field_font_color: fontColor,
    field_level_style: styleLevel,
    field_level: mainHeadlineLevel = 1,
  } = data;

  // What the main headline looks like
  const mainHeadlineStyleLevel = styleLevel || mainHeadlineLevel;

  // Level of the sub headline. Should be 2 levels below main level (but minumum 6 of course)
  const subHeadlineLevel = Math.min(mainHeadlineLevel + 2, 6) as HeadlineLevel;

  // What the sub headline looks like. Should be 2 below main level (but minumum 6 of course)
  const subHeadlineStyleLevel = styleLevel
    ? (Math.min(mainHeadlineStyleLevel + 2, 6) as HeadlineLevel)
    : subHeadlineLevel;

  return (
    <div
      className={classes(
        `text-size-h${subHeadlineStyleLevel}`,
        headlineStyles({ textAlign }),
        headlineFont,
      )}
      style={{ color: fontColor }}
    >
      {subHeadlineText && <SoftHyphenInjector text={subHeadlineText} />}
    </div>
  );
};
